import { useTranslation } from 'react-i18next';
import { Box, X, ChevronsUpDown } from 'lucide-react';

import { ProjectSiteSelector } from '@/features/routing';

interface SidebarHeaderProps {
  projectName: string;
  siteName: string;
  instanceName: string;
  isCluster: boolean;
  isMobile: boolean;
  isCollapsed?: boolean;
  closeSidebar: () => void;
}

export const SidebarHeader = ({
  projectName,
  siteName,
  instanceName,
  isCluster,
  isMobile,
  isCollapsed,
  closeSidebar
}: SidebarHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="p-3 flex items-center gap-3 h-16 ">
      <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shrink-0 text-white">
        {isMobile ? (
          <button onClick={closeSidebar} className="z-10" aria-label={t('common.navigation.closeMenu', 'Close menu')}>
            <X className="w-5 h-5" />
          </button>
        ) : (
          <Box className="w-5 h-5" />
        )}
      </div>

      {!isCollapsed && (
        <ProjectSiteSelector>
          <div
            className={`flex-1 overflow-hidden transition-colors rounded-md p-1 -m-1 group cursor-pointer ${
              isMobile ? 'active:bg-accent' : 'hover:bg-accent'
            }`}>
            <div className="flex items-center gap-1">
              <div className="font-semibold text-sm truncate">{projectName || instanceName || 'RITA'}</div>
              <ChevronsUpDown className="w-3.5 h-3.5 text-muted-foreground/50 group-hover:text-muted-foreground transition-colors shrink-0" />
            </div>
            <div className="text-xs text-muted-foreground truncate">
              {siteName || (isCluster ? 'Cluster Mode' : 'Single Instance')}
            </div>
          </div>
        </ProjectSiteSelector>
      )}
    </div>
  );
};
